import allImgPaths from 'assets/images'
import { InputTextField } from 'components/InputField'
import Otp from 'components/Otp'
import Toast from 'components/common/Toast'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { sendOtp, verifyOtp } from 'services/vendor'

const VendorOtp = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState<any>(null);
    const [otpValue, setOtpValue] = useState('')
    const [errors, setErrors] = useState<any>({})

    useEffect(() => {
        const vendorEmail = localStorage.getItem('vendorEmail')
        setEmail(vendorEmail)
    }, [])

    const handleOtp = (e: any) => {
        setOtpValue(e)
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault()
        
        setErrors({ otp: false })

        try {
            const { data } = await verifyOtp({ email, code: otpValue })

            if (data) {
                const userData = {
                    accessToken: data.accessToken,
                    name: data?.name,
                    refreshToken: data.refreshToken,
                    id: data._id,
                    profile_image: data.profile_image,
                };
                localStorage.setItem("vendorData", JSON.stringify(userData));
                setOtpValue("")
                navigate("/vendor/onboarding1");
                // Check if user is part of any team or has any pending invitation
            }
            Toast.success('Login successful', '')
        } catch (error) {
            setErrors({ otp: true })
            console.log({ vendorOtpError: error })
        }
    }

    const resend = async () => {
        try {
            const { data } = await sendOtp({ email })
            if (data) {
                Toast.info('OTP resent successfully', '')
            }
        } catch (error) {
            console.log({ sendOtpError: error })
        }

    }

    return (
        <div className="flex">
            {/* Left banner */}
            <div className="w-1/2">
                <div className="bg-[#1E0AF5] flex flex-col justify-center items-center h-screen">
                    <img src={allImgPaths.vendorLoginBanner} alt="" />
                </div>
            </div>

            {/* Right banner */}
            <div className="w-1/2 flex flex-col">
                <div className="w-full h-screen flex items-center overflow-y-auto">
                    <div className="w-full max-w-[360px] mx-auto">
                        {/* Logo */}
                        <div className="text-center pb-6">
                            <img className="inline-block w-[220px]" src={allImgPaths.mainLogo} alt="logo" />
                        </div>

                        {/* icon */}
                        <img className='block mx-auto mb-6' src={allImgPaths.vendorMessageIcon} alt="" />

                        {/* Heading */}
                        <h1 className="font-interSemiBold text-[30px] text-[#101828] pb-4 text-center">Check your email</h1>

                        <div className="pb-6 text-center">
                            <p className='text-[#475467] text-sm pb-0.5'>We sent a verification code to</p>
                            <p className='text-[#101828] text-sm font-interMedium flex items-center justify-center gap-x-1'>
                                {email}
                                <img
                                    src={allImgPaths.EditIcon2}
                                    className='cursor-pointer hover:bg-[#f2f4f7] rounded w-6 p-1'
                                    onClick={() => navigate('/vendor/login')}
                                    alt=""
                                />
                            </p>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="flex gap-x-3 justify-center">
                                <Otp onChangeOtp={handleOtp} borderColor={errors?.otp && "#D92D20"} />
                            </div>

                            {/* Didn't get code */}
                            <p className="text-right -mr-[50px]">
                                <span className="text-[#475467] text-sm">Didn’t get the code?</span>
                                <Link
                                    className="text-sm font-interSemiBold text-[#1E0AF5] hover:text-[#0C0462]"
                                    to="#"
                                    onClick={resend}
                                >
                                    {' '} Resend
                                </Link>
                            </p>
                            <div className="justify-center gap-x-3 flex mt-5">
                                <button
                                    type="submit"
                                    className={`submit-btn-blue blue-btn-hover w-full max-w-[360px] !px-9 ${(!otpValue || otpValue.length < 6) ? 'button-disabled' : ''}`}
                                >
                                    Verify Email
                                </button>
                            </div>
                        </form>

                        {/* Already Account */}
                        {/* <div className="pt-8 text-center pb-6">
                            <span className='text-[#475467] text-sm'>Already have an account? </span>
                            <Link
                                className="text-sm font-interSemiBold text-[#4B3BF7] hover:text-[#0C0462]"
                                to="/login"
                            >
                                Log in
                            </Link>
                        </div> */}

                        <div className="pt-8 text-center pb-2 flex items-center justify-center gap-x-2 text-[#545454]">
                            <Link
                                className="text-sm text-[#545454] hover:text-[#1e0af5]"
                                to="/login"
                            >
                                Terms of use
                            </Link>
                            |
                            <Link
                                className="text-sm text-[#545454] hover:text-[#1e0af5]"
                                to="/login"
                            >
                                Privacy policy
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VendorOtp